import { generateUUID, getQueryString } from '@/utils/utils'
import xss from 'xss'
import Fingerprintjs from '@fingerprintjs/fingerprintjs'
import md5 from 'blueimp-md5'
import { id } from 'date-fns/locale'
/*
  @params
  topicId:题目id
  list: 题目列表
*/
export const getTopicByTopicId = (topicId, topics) => {
  let topic = {}
  let index = 0
  topics.forEach((item, sindex) => {
    if (item.id === topicId) {
      topic = item
      index = sindex
    }
  })
  return {
    topic,
    index
  }
}

/**
 *获取提交问卷参数
 *
 * @param {*} data
 * @return {*}
 */
export const getAnswerSurveyparams = (data, props, pageTopicId = '') => {
  const { surveyStatus, version, isDraft } = props.surveyData
  const isTest = Boolean(getQueryString('isTest'))
  const serverId = getQueryString('serverId')
  const visitorId = getQueryString('visitorId')
  const instanceId = getQueryString('instanceId')
  // console.log(props)
  const params = {
    serverId,
    visitorId,
    surveyId: props.surveyId,
    collector: props.code,
    createLanguageCode: props.createLanguageCode,
    // startTime: props.startTime,
    details: [],
    isTest: isTest ? 1 : 0,
    surveyStatus,
    version,
    isDraft,
    surveyUrl: window.location.href,
    pageTopicId: pageTopicId,
    instanceId: instanceId || ''
  }
  //下拉题，单选、多选、矩阵单选、矩阵多选
  const topicTypeList = [1, 2, 3, 9, 12, 20]
  //矩阵题
  const matrixTypeList = [3, 9, 14, 18]
  //多选
  const checkboxTypeList = [2, 9]
  const answerList: any[] = []
  data.forEach((item) => {
    let param = {
      surveyTopicId: '',
      answerContent: '',
      optionData: [] //{optionId: '', answerContent: ''}
    }
    const type = item.topicType
    param.surveyTopicId = item.bizId
    if (topicTypeList.includes(type)) {
      if (matrixTypeList.includes(type)) {
        if (checkboxTypeList.includes(type)) {
          item.matrixValue.forEach((sitem) => {
            param = {
              surveyTopicId: '',
              answerContent: '',
              optionData: [] //{optionId: '', answerContent: ''}
            }
            param.surveyTopicId = sitem.subTopicId
            sitem.value.forEach((bitem) => {
              param.optionData.push({
                optionId: bitem,
                answerContent: ''
              })
            })
            answerList.push(param)
          })
        } else {
          item.matrixValue.forEach((sitem) => {
            param = {
              surveyTopicId: '',
              answerContent: '',
              optionData: [] //{optionId: '', answerContent: ''}
            }
            param.surveyTopicId = sitem.subTopicId
            param.optionData.push({
              optionId: sitem.value,
              answerContent: ''
            })
            answerList.push(param)
          })
        }
      } else {
        if (checkboxTypeList.includes(type)) {
          item.values.forEach((sitem) => {
            param.optionData.push({
              optionId: sitem,
              answerContent: item[`inputValue_${sitem}`]
            })
          })
          answerList.push(param)
        } else {
          param.optionData.push({
            optionId: item.value,
            answerContent: item[`inputValue_${item.value}`]
          })
          answerList.push(param)
        }
      }
    } else {
      if (matrixTypeList.includes(type)) {
        item.matrixValue.forEach((sitem) => {
          param = {
            surveyTopicId: '',
            answerContent: '',
            optionData: [] //{optionId: '', answerContent: ''}
          }
          param.surveyTopicId = sitem.subTopicId
          param.answerContent = sitem.value
          answerList.push(param)
        })
      } else {
        // 城市题需要特殊处理一下
        if (type === 21) {
          param.answerContent = item.values?.join('/')
        } else {
          param.answerContent = item.value
        }
        answerList.push(param)
      }
    }
  })
  params.details = answerList
  return params
}

export const getSurveyHeight = (dom) => {
  const childList = Array.from(dom.childNodes)
  const height = childList.reduce((total, currentDom) => {
    return total + currentDom.offsetHeight
  }, 0)
  return Number(height) + 20
}

//获取iframe父页面的url
export const getParentUrl = () => {
  let url = window.location.origin
  if (parent !== window) {
    try {
      url = parent.location.href
    } catch (e) {
      url = document.referrer
    }
  }
  return url
}

function hashstr(s) {
  let hash = 0
  if (s.length == 0) return hash
  for (let i = 0; i < s.length; i++) {
    let char = s.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }
  return hash
}

export const getUserInfo = async () => {
  //获取用户信息
  const usr_source = getQueryString('usr_source')
  const usr_medium = getQueryString('usr_medium')
  const usr_campaign = getQueryString('usr_campaign')
  const usr_content = getQueryString('usr_content')
  const usr_term = getQueryString('usr_term')
  // const fs = await Fingerprintjs.load()
  // const result = await fs.get()
  //idvisitor需要添加当前问卷的url，并且md5加密,需要获取href
  // const parentUrl = getParentUrl()
  // const currentSurveyUrl = window.location.href
  // 默认从url上面取，没有就前端uuid生成
  // const idvisitor = md5(result.visitorId + parentUrl + currentSurveyUrl)
  let idvisitor =
    getQueryString('idvisitor') ||
    getQueryString('pushdeviceid') ||
    getQueryString('ssoid')
  if (!idvisitor || idvisitor === 'null') {
    // 优先从缓存里面取
    idvisitor = localStorage.getItem('idvisitor')
    //缓存中没有就生成新的
    if (!idvisitor || idvisitor === 'null') {
      idvisitor = generateUUID()
      localStorage.setItem('idvisitor', idvisitor)
    }
  }
  const pushdeviceid = getQueryString('pushdeviceid')
  sessionStorage.setItem(
    'userInfo',
    JSON.stringify({
      usr_source,
      usr_medium,
      usr_campaign,
      usr_content,
      usr_term,
      idvisitor,
      pushdeviceid
    })
  )
}
//需要处理xss的白名单字段
// const xssParams = ['aggrement', 'surveyName', 'foreword', 'endword']
const myxss = new xss.FilterXSS({
  whiteList: {
    a: ['href', 'title', 'target', 'style'],
    img: ['src', 'style'],
    p: ['style'],
    span: ['style'],
    h1: ['style'],
    h2: ['style'],
    h3: ['style'],
    h4: ['style'],
    h5: ['style'],
    br: ['style'],
    blockquote: [],
    i: ['style'],
    b: ['style'],
    u: ['style'],
    font: ['size', 'style', 'color'],
    strike: ['style'],
    div: ['style'],
    strong: ['style'],
    em: ['style']
  }
})
export const dealToXss = (obj) => {
  let target
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      //数组
      target = []
      obj.forEach((item) => {
        target.push(dealToXss(item))
      })
    } else if (obj) {
      target = {}
      let objKeys = Object.keys(obj)
      objKeys.forEach((key) => {
        target[key] = dealToXss(obj[key])
      })
    } else {
      target = obj
    }
  } else {
    target = typeof obj === 'string' ? myxss.process(obj) : obj
  }
  return target
}
